import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useDashboardBanner } from "../hooks";

export const DashboardBanner = () => {
  const { getDashboardBannerData } = useDashboardBanner();
  const { data } = !!getDashboardBannerData && getDashboardBannerData;

  const settings = {
    dots: true,
    infinite: data?.length > 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="banner-slider slick-slider">
      <Slider {...settings}>
        {data &&
          data?.map((element, index) => (
            <img
              src={element}
              alt=""
              className="mw-100 banner-image"
              key={`dashboard-banner-item-no-${index}`}
            />
          ))}
      </Slider>
    </div>
  );
};
